import React, { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import NightsStayIcon from '@material-ui/icons/NightsStay';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  container: {
    marginLeft: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 600px)': {
      marginLeft: '0.25rem',
    }
  },
  iconButton: {
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    [theme.breakpoints.down('xs')]: {
      padding: '8px',
    }
  }
});

function ThemeSwitcher({ classes }) {
  const { themeName, toggleTheme } = useContext(ThemeContext);
  const isDark = themeName === 'kinetic';

  return (
    <div className={classes.container}>
      <Tooltip title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"} placement="bottom" arrow>
        <IconButton
          className={classes.iconButton}
          onClick={toggleTheme}
          aria-label="Toggle Theme"
        >
          {isDark ? <WbSunnyIcon /> : <NightsStayIcon />}
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default withStyles(styles)(ThemeSwitcher);
